import * as React from 'react';
import { Box } from '../../designSystem/components/box';
import { Flex } from '../../designSystem/components/flex';
import { Spacer } from '../../designSystem/components/spacer';
import { DocumentBaseOptions } from '../../generated/types';
import { isValidColor } from '../../util/color';
import { A4_SIZES } from '../../util/pdf';
import { isNonEmptyString } from '../../util/string';

interface IDocumentContainerProps {
    children: React.ReactNode;
    headerTitle1: string;
    headerTitle2: string;
    options: DocumentBaseOptions;
}

export const DocumentContainer = (props: IDocumentContainerProps) => {
    const headerColor = isValidColor(props.options.headerColor)
        ? props.options.headerColor
        : 'white';

    return (
        <Flex
            css={{
                color: isValidColor(props.options.textColor) ? props.options.textColor : '$gray800',
                background: isNonEmptyString(props.options.background?.content)
                    ? `url(${props.options.background?.content})`
                    : '#5230a1',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                fontFamily: props.options.fontFamily || 'Open Sans',
                fontSize: '12px',
                minHeight: `${A4_SIZES['96dpi'].height}px`,
                pageBreakBefore: 'always'
            }}
            direction="column"
            width={A4_SIZES['96dpi'].width}
        >
            <Flex
                align="end"
                css={{
                    marginTop: '51px',
                    px: '16px'
                }}
                direction="column"
                gap="1"
            >
                <Box
                    css={{
                        color: headerColor,
                        fontSize: '13px',
                        fontWeight: '700',
                        lineHeight: '18px'
                    }}
                >
                    {props.headerTitle1}
                </Box>

                <Box
                    css={{
                        color: headerColor,
                        fontSize: '24px',
                        fontWeight: '700',
                        textTransform: 'uppercase'
                    }}
                >
                    {props.headerTitle2}
                </Box>
            </Flex>

            <Spacer height="7" />

            <Flex
                css={{
                    minHeight: '971px',
                    paddingBottom: '$6',
                    paddingLeft: '$4',
                    paddingRight: '$4'
                }}
                gap="4"
                width={1}
            >
                <Flex
                    css={{
                        background: 'white',
                        borderRadius: '$3',
                        flex: '1',
                        fontSize: '12px',
                        overflowX: 'hidden',
                        padding: '$4'
                    }}
                    direction="column"
                >
                    {props.children}
                </Flex>
            </Flex>
        </Flex>
    );
};
